import React, {useEffect, useState} from "react";
import {apiGetDevice} from "./Actions";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import DeviceTable from "./DeviceTable";
import {FiPlus} from "react-icons/fi";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";
import {EmptyState} from "../components/Table";

const Device = () => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetDevice(user.activeAreal.id, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání zařízení nastala chyba.");
            setData(null);
            setLoading(false);
        });
    };

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám zařízení..."}/>;
        if (!loading && data) return <DeviceTable data={data} setData={setData}/>;
        else return <EmptyState/>;
    };

    return (
        <>
            {user.activeAreal && (
                <>
                    <PageHeader crumbs={[{label: "Zařízení"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton link="/device/add" text="PŘIDAT ZAŘÍZENÍ" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {_renderBody()}
                </>
            )}
        </>
    );
};

export default Device;
